<template>
  <span class="app-image-stub" />
</template>

<script>
export default {
  name: 'AppImageStub',
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.app-image-stub {
  display: block;
  background-color: vars.$c-img-bg;
}
</style>
